import { useParams } from "react-router";
import { MainContainerForm, MainPadding } from "../../../styles/Main.styles";
import Form from "../form/Form";

export default function Creation() {
  const { idCategory } = useParams();

  return (
    <MainPadding>
      <MainContainerForm>
        <Form idBrand={idCategory} />
      </MainContainerForm>
    </MainPadding>
  );
}
